<template>
  <validation-observer ref="formObserver" v-slot="{ passes }" tag="div">
    <form @submit.prevent="passes(saveForm())">
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head flex justify-between">
          <p class="modal-card-title">
            Editing Test Result for {{ testResult.username }}
          </p>
        </header>
        <section class="modal-card-body">
          <validation-provider v-slot="{ errors }" vid="generic" slim>
            <d-message v-if="errors.length > 0" type="error" class="w-full mb-3">
              {{ errors[0] }}
            </d-message>
          </validation-provider>
          <d-message type="warning" class="w-full mb-5">
            Results edited on this screen will not be adjusted in Filemaker. You will need to adjust those manually.
          </d-message>
          <d-field label="Final Percentage (%)">
            <d-input v-model="computedFinalPercentage" type="number" min="0" max="100" />
          </d-field>
          <d-field label=" ">
            <d-switch v-model="form.passed">
              Passed
            </d-switch>
          </d-field>
        </section>
        <footer class="modal-card-foot justify-end">
          <d-btn flat @click="$parent.close()">
            Cancel
          </d-btn>
          <d-btn :loading="saving" type="submit">
            Save Changes
          </d-btn>
        </footer>
      </div>
    </form>
  </validation-observer>
</template>
<script>
  import axios from 'axios';

  export default {
    props: {
      testResult: {
        type: Object,
        default: () => ({}),
      },
    },

    data() {
      return {
        saving: false,
        form: {
          finalPercentage: 0,
          passed: 0,
        },
      };
    },

    computed: {
      computedFinalPercentage: {
        get: vm => vm.form.finalPercentage * 100,
        set(val) {
          this.form.finalPercentage = val / 100;
        },
      },
    },

    mounted() {
      if (this.testResult) {
        this.form = JSON.parse(JSON.stringify(this.testResult));
      }
    },

    methods: {
      async saveForm() {
        this.saving = true;
        try {
          await axios.patch(`/api/tests/${this.testResult.id}`, this.form);
          this.$parent.events.getTestsPaged();
          this.$parent.close();
        } catch (error) {
          await this.$toast.error(error.response.data[0]);
        } finally {
          this.saving = false;
        }
      },
    },
  };
</script>